import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import classnames from 'classnames'

import PropTypes from 'prop-types'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { userRegister } from '../actions/user-session'

class Register extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: '',
      email: '',
      password: '',
      isRegistering: false,
      error: null
    }

    this.name = React.createRef()
    this.email = React.createRef()
    this.password = React.createRef()
  }

  componentWillMount() {
    const { email } = this.props

    if (email) this.setState({email})
  }

  componentDidMount() {
    const { email } = this.state

    if (email && this.name.current) {
      this.name.current.focus()
    } else
    if (this.email.current) {
      this.email.current.focus()
    }
  }

  onSubmit(e) {
    e.preventDefault()

    const { requestCode } = this.props
    const { name, email, password, isRegistering } = this.state

    if (!name || !email || !password) {
      let credentials = 'credentials'
      credentials = !name ? 'full name' : credentials
      credentials = !email ? 'email' : credentials
      credentials = !password ? 'password' : credentials
      credentials = !name && !email ? 'full name and email' : credentials
      credentials = !name && !password ? 'full name and password' : credentials
      credentials = !email && !password ? 'email and password' : credentials
      credentials = !name && !email && !password ? 'full name, email and password' : credentials

      this.setState({error: `Please enter your ${credentials}.`})
    } else
    if (isRegistering === false) {
      this.setState({isRegistering: true, error: null}, () => this.props.userRegister({name, email, password}, requestCode))
    }
  }

  render() {
    const { modal, userSession, requestCode } = this.props
    const { name, email, password, isRegistering, error } = this.state

    const className = classnames({
      'register': true,
      'register--modal': modal === true
    })

    const formClassName = classnames({
      'valid': this.state.email && this.state.password
    })

    const buttonClassName = classnames({
      'button--disabled': isRegistering,
      'placeholder-loader': isRegistering,
      'placeholder-loader--success': isRegistering
    })

    return (
      <div className={className}>
        {
          userSession.registration
          ? <div style={{textAlign: 'center'}}>
              <p>A verification email has just been sent over to {userSession.registration.email}</p>
            </div>
          : <form className={formClassName} onSubmit={this.onSubmit.bind(this)}>
              <ul className="group" data-error-msg={error}>
                <h1 className="h1--default">Sign up for Ridline account</h1>

                <li data-title="Email">
                  <input ref={this.email}
                    type="email"
                    className="input--light"
                    value={email}
                    onChange={(e) => this.setState({email: e.target.value})}
                    />
                </li>

                <li data-title="Full name">
                  <input ref={this.name}
                    type="text"
                    className="input--light"
                    value={name}
                    onChange={(e) => this.setState({name: e.target.value})} />
                </li>

                <li data-title="Password">
                  <input ref={this.password}
                    type="password"
                    className="input--light"
                    value={password}
                    onChange={(e) => this.setState({password: e.target.value})} />
                </li>
              </ul>

              <button className={buttonClassName} type="submit">Register</button>

              <Link to="/login">Already a user? Log in instead</Link>
            </form>
        }
      </div>
    )
  }
}

Register.propTypes = {
  modal: PropTypes.bool,
  email: PropTypes.string,
  userSession: PropTypes.object,
  requestCode: PropTypes.string,
  userRegister: PropTypes.func
}

Register.defaultProps = {
  modal: false,
  email: '',
  userSession: {},
  requestCode: undefined,
  userRegister: function() {}
}

export const mapStateToProps = (state) => {
  return {
    userSession: state.userSession
  }
}

export const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    userRegister
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Register)



// WEBPACK FOOTER //
// ./src/containers/register.js